export { useNavigateToTeamsApp } from '../src/useNavigateToTeamsApp.ts';
